<script setup lang="ts"></script>
<template>
  <div class="flex items-center w-full gap-2 lg:gap-4">
    <div class="flex grow items-center gap-2">
      <slot name="title" />
    </div>
    <div class="flex grow-0 items-center">
      <slot name="button" />
    </div>
  </div>
</template>
